<template>
  <div class="l-how-to-buy-landing-page">
    <vHeroSection mode="buy" />
    <vCarouselSection />
    <vRegisterSection />
    <vSafetySection />
    <vFollowUpSection />
    <vEnjuappSection mode="buy" />
  </div>
</template>

<script>
  import vHeroSection from './how-to/hero.vue'
  import vCarouselSection from './how-to/carousel.vue'
  import vRegisterSection from './how-to-buy/register.vue'
  import vSafetySection from './how-to-buy/safety.vue'
  import vFollowUpSection from './how-to-buy/follow-up.vue'
  import vEnjuappSection from './how-to/enjuapp.vue'

  export default {
    components: {
      vHeroSection,
      vCarouselSection,
      vRegisterSection,
      vSafetySection,
      vFollowUpSection,
      vEnjuappSection
    }
  }
</script>

<style lang="scss" scoped>
  .l-how-to-buy-landing-page {
    color: $color-text-extra-dark;
    padding: 0;
    text-align: center;
    text-transform: lowercase;
  }
</style>
